import { render, staticRenderFns } from "./BoundedTextContainer.vue?vue&type=template&id=5850de1b"
import script from "./BoundedTextContainer.vue?vue&type=script&lang=js"
export * from "./BoundedTextContainer.vue?vue&type=script&lang=js"
import style0 from "./BoundedTextContainer.vue?vue&type=style&index=0&id=5850de1b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports